import { render } from "./PageNavigation.vue?vue&type=template&id=571b8d6f&scoped=true"
import script from "./PageNavigation.vue?vue&type=script&lang=js"
export * from "./PageNavigation.vue?vue&type=script&lang=js"

import "./PageNavigation.vue?vue&type=style&index=0&id=571b8d6f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571b8d6f"]])

export default __exports__